import { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";
//imported
import { STORAGE_PLANS, PAGE_LIMIT } from "common/viewContent";
import { CONFIRM_ALERT } from "common/constantMessage";
import * as actions from "store/actions";
import * as Path from "routes/paths";
import { formatText } from "helpers/common";
import ReactPagination from "components/shared/ReactPagination";
import { deleteStoragePlan, getStoragePlansList } from "store/services/storagePlansService";
import SortableTable from "components/shared/SortableTable";
import { generatePath } from "react-router-dom";

const List = ({
  dispatch,
  isLoading
}) => {
  //pagination
  const [activePage, setActivePage] = useState(1);
  const [plansList, setPlansList] = useState(null);
  const [totalItemsCount, setTotalItemsCount] = useState(0);

  //get
  async function getData() {
    try {
      let query = {
        page: activePage,
        limit: PAGE_LIMIT,
      };
      dispatch(actions.persist_store({ loader: true }));
      const response = await getStoragePlansList(query);
      if (response?.success && response?.body?.data?.length) {
        setPlansList(response?.body?.data);
        setTotalItemsCount(response?.body?.total_count || 0);
      }
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      dispatch(actions.persist_store({ loader: false }));
      console.log(err);
    }
  }
  useEffect(() => {
    getData();
  }, [activePage]);

  //delete
  const deleteItem = async (id) => {
    try {
      let isConfirm = await CONFIRM_ALERT();
      if(!isConfirm) {
        return;
      }

      dispatch(actions.persist_store({ loader: true }));
      await deleteStoragePlan(id);
      await getData();
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      console.log(err);
      dispatch(actions.persist_store({ loader: false }));
    }
  };
  //pagination
  const handlePageChange = (page) => {
    setActivePage(page);
    window.scrollTo(0, 0);
  };

  const columns = useMemo(() => {
    return [
      {
        key: "plan_name"
      },
      {
        key: "storage_size",
        render: (item) => `${item.storage_size} MB`,
      },
      {
        key: "price",
        render: (item) => `$${item.price} USD`,
      },
      {
        key: "product_id"
      },
      {
        key: "price_id"
      },
      {
        key: "status",
        render: (item) => formatText(item?.status),
      },
      {
        key: "Action",
        label: "Action",
        render: (item) => (
          <div className="d-flex align-items-center gap-10 tableBtn">
            <Link
              to={generatePath(Path.storage_plan_edit, { id: item.id })}
              title="Edit"
            >
              <i className="fa fa-lg fa-edit"></i>
            </Link>
            <span
              className="text-danger"
              onClick={() => deleteItem(item.id)}
            >
              <i
                className="fa fa-lg fa-trash"
                title="Delete"
              ></i>
            </span>
          </div>
        )
      },
    ]
  }, [])


  return (
    <>
      <Helmet title={STORAGE_PLANS.CURRENT_MODULE} />
      <section className="section">
        <div className="section-header">
          <h1>{STORAGE_PLANS.CURRENT_MODULE}</h1>
          <div className="section-header-button">
            <Link to={Path.storage_plan_add} className="btn btn-primary">
              Add New
            </Link>
          </div>
          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item">Manage Storage Plans</div>
          </div>
        </div>
        <div className="section-body">
          <h2 className="section-title">{STORAGE_PLANS.CURRENT_MODULE}</h2>
          <p className="section-lead">
          In this section, you can create and manage storage upgrade plans for the Practitioners,
          including options to edit and delete them. These changes will be reflected in the Practitioner dashboard.
          </p>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h4>{STORAGE_PLANS.TOP_CONTENT}</h4>
                </div>
                <div className="card-body">
                  {/* <div className="float-left">
                                <select className="form-control selectric">
                                    <option>Action For Selected</option>
                                    <option>Move to Draft</option>
                                    <option>Move to Pending</option>
                                    <option>Delete Pemanently</option>
                                </select>
                            </div> */}
                  {/* <div className="float-right"> */}
                  {/* <form>
                                <div className="input-group">
                                <input type="text" className="form-control" placeholder="Search" />
                                <div className="input-group-append">                                            
                                    <button className="btn btn-primary"><i className="fas fa-search"></i></button>
                                </div>
                                </div>
                            </form> */}
                  {/* </div> */}

                  {/* <div className="clearfix mb-3"></div> */}

                  <div className="table-responsive">
                  <SortableTable
                      columns={columns}
                      data={plansList}
                      isLoading={isLoading}
                    />
                  </div>
                  {plansList?.length > 0 && (
                    <ReactPagination
                      activePage={activePage}
                      itemsCountPerPage={PAGE_LIMIT}
                      totalItemsCount={totalItemsCount}
                      handlePageChange={handlePageChange}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    subscriptionList: state.Subscription.subscriptions,
    isLoading: state.persistStore.loader,
  };
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToProps, mapDispatchToProps)(List);
